module.exports = __webpack_public_path__ + "static/media/nishant.44a6bd67.jpeg";